<template>
  <BaseDialog
    centered
    v-if="opportunityLabel"
    contentClass="delete-opportunity-label"
    ref="dialog"
    :show-actions="true"
  >
    <template slot="title">{{ $t('page.admin-opportunity-labels.delete-dialog.title') }}</template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div class="delete-opportunity-label__current-label">
          <span class="delete-opportunity-label__current-label-text">{{
            $t('page.admin-opportunity-labels.delete-dialog.are-you-sure')
          }}</span>
          <BaseStatusBadge :color="opportunityLabel.color" :text="opportunityLabel.name" />
        </div>
        <div class="delete-opportunity-label__warning-notice">
          <div class="delete-opportunity-label__alert-icon">
            <BaseIcon name="alert-circle" />
          </div>
          <div class="delete-opportunity-label__warning-notice-text">
            <span>{{ $t('page.admin-opportunity-labels.delete-dialog.warning') }}</span>
          </div>
        </div>
        <div class="delete-opportunity-label__actions">
          <FormButton is-outlined class="delete-opportunity-label__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit">
            <span>{{ $t('actions.confirm') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import { mapActions } from 'vuex';
import BaseStatusBadge from '@/components/base/BaseStatusBadge.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'DeleteOpportunityLabelDialog',
  components: {
    BaseIcon,
    BaseStatusBadge,
    BaseDialog,
    FormButton,
  },
  data() {
    return {
      opportunityLabel: null,
    };
  },
  methods: {
    ...mapActions('opportunityLabels', ['deleteOpportunityLabel']),
    openDialog(opportunityLabel) {
      this.opportunityLabel = opportunityLabel;
      this.$nextTick(() => {
        this.$refs.dialog.openModal();
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      this.deleteOpportunityLabel(this.opportunityLabel.id)
        .then(() => {
          this.$toast.success(this.$t('page.admin-opportunity-labels.delete-dialog.delete-opportunity-label-success'));
          this.$emit('action-succeeded');
        })
        .catch((error) => this.$toast.error(error));
      this.closeDialog();
    },
    handleKeyup(event) {
      const keyCode = event.keyCode || event.charCode;

      if (keyCode === 13 && this.opportunityLabel) {
        this.onSubmit();
      }
    },
    cancelClick() {
      this.closeDialog();
    },
  },
  created() {
    document.addEventListener('keyup', this.handleKeyup);
  },
  destroyed() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>

<style lang="scss">
.base-dialog__delete-opportunity-label {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.delete-opportunity-label {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__current-label {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &-text {
      color: $color-normal;
    }
  }

  &__warning-notice {
    margin: 32px 0 16px 0;
    font-size: 14px;
    background: $color-red-100;
    padding: 8px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    gap: 16px;

    &-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-size: 16px;
    }
  }

  &__alert-icon {
    width: 24px;
    height: 24px;
    color: $color-error;
  }
}
</style>
